module.exports = __webpack_public_path__ + "media/application/images/icons/clock-862351970bae67fca67ed0f66a83eda1.svg";